import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  formatDate,
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  showDeleteDialog,
  activeFormatter,
  showConfirmDialog,
  checkPermision,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { editRole, removeById, removeByIdRole, selectPermissionRole } from "./userSlice";

export const RoleTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
  handleSearch,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const permission = useSelector(selectPermissionRole);

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);

  const handleDelete = async (row) => {
    console.log(row, "row");
    const id = { role_id: `${row.role_id}` };
    console.log("id", id);

    const action = await showDeleteDialog(
      `Are you sure you want to delete?<br><strong>${row.role_description}</strong>`
    );
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeByIdRole({ data: id }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await window.location.reload();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex) => {
    return (
      <div>
        <OverlayTrigger
          overlay={
            <Tooltip id="products-edit-tooltip">Permission User</Tooltip>
          }
        >
          <a
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
            onClick={() => {
              history.push(
                `/administration/management-user/role/view/${row.role_id}`,
                { params: row.role_description }
              );
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl( "/media/svg/icons/New/Search.svg")} />
            </span>
          </a>
        </OverlayTrigger>
        {checkPermision(permission, "UPDATE") && (
          <>
            {row.is_enable === "Y" && (
              <OverlayTrigger
                overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
              >
                <div
                  className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
                  onClick={() => {
                    history.push(
                      `/administration/management-user/role/edit/${row.role_id}`,
                      { params: row.role_description }
                    );
                  }}
                >
                  <span className="svg-icon svg-icon-md svg-icon-light">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
                  </span>
                </div>
              </OverlayTrigger>
            )}
          </>
        )}

        {checkPermision(permission, "UPDATE") && (
          <>
            {row.is_enable === "Y" && (
              <OverlayTrigger
                overlay={<Tooltip id="products-edit-tooltip">Disabled</Tooltip>}
              >
                <div
                  className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                  onClick={() => handleDisabled(e, row, rowIndex)}
                >
                  <span className="svg-icon svg-icon-md svg-icon-light">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/New/eye-slash.svg")}
                    />
                  </span>
                </div>
              </OverlayTrigger>
            )}
            {row.is_enable === "N" && (
              <OverlayTrigger
                overlay={<Tooltip id="products-edit-tooltip">Enabled</Tooltip>}
              >
                <div
                  className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                  onClick={() => handleEnable(e, row, rowIndex)}
                >
                  <span className="svg-icon svg-icon-md svg-icon-primary">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/New/eye.svg")} />
                  </span>
                </div>
              </OverlayTrigger>
            )}
          </>
        )}
      </div>
    );
  };
  const columns = [
    {
      text: "No",
      dataField: "no",
      // sort: true,
      // sortCaret: sortCaret,
      // headerSortingClasses,
      style: { width: "40px" },
      headerAlign: "center",
    },
    {
      text: "Name",
      dataField: "role_description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "130px" },
      headerAlign: "center",
    },
    {
      text: "Created User",
      dataField: "created_user",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "130px" },
      headerAlign: "center",
    },
    {
      text: "Created Date",
      dataField: "created_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDate,
      style: { minWidth: "130px" },
      headerAlign: "center",
    },
    {
      text: "Actions",
      dataField: "actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
    },
  ];

  const handleDisabled = async (e, row, rowIndex) => {
    const params = {
      role_id: row.role_id,
      role_description: row.role_description,
      is_enable: "N",
    };
    console.log(params);

    const action = await showConfirmDialog(`Are you sure want to disabled?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editRole(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const handleEnable = async (e, row, rowIndex) => {
    const params = {
      role_id: row.role_id,
      role_description: row.role_description,
      is_enable: "Y",
    };
    console.log(params);

    const action = await showConfirmDialog(`Are you sure want to enable?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editRole(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  // permision VIew
  const [showPermision, setShowPermision] = useState(false);
  const [idPermision, setIdPermision] = useState("");

  const handleClosePermision = () => setShowPermision(false);
  const handleShowPermision = () => setShowPermision(true);

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden mt-4"
        bootstrap4
        
        keyField="no"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
    </>
  );
};
